document.addEventListener("alpine:init", () => {
  Alpine.data("bundlesV3", () => {
    return {
      options: [],
      selectedIdx: 0,
      bundleForm: null,

      init() {
        this.bundleForm = this.$refs?.bundleForm || null;

        const dataEl = this.$refs?.optionsData;
        if (dataEl) {
          try {
            this.options = JSON.parse(dataEl.textContent);
          } catch (e) {
            this.options = [];
          }
        }

        const defaultFromOptions = this.options.findIndex(
          (opt) => opt.defaultSelected
        );
        this.selectedIdx = defaultFromOptions >= 0 ? defaultFromOptions : 0;
        this.selectOption(this.selectedIdx);

        window.addEventListener("kilgour:buybox:request-state", () => {
          this.emitStickyState();
        });
      },

      get currentOption() {
        return this.options[this.selectedIdx] || this.options[0] || null;
      },

      selectOption(idx) {
        if (idx < 0 || idx >= this.options.length) return;
        this.selectedIdx = idx;
        this.updateForm();
      },

      updateForm() {
        const opt = this.currentOption;
        if (!this.bundleForm || !opt) return;

        const variantField = this.bundleForm.querySelector('input[name="id"]');
        const sellingPlanField = this.bundleForm.querySelector(
          'input[name="selling_plan"]'
        );

        if (variantField && opt.variantId) {
          variantField.value = opt.variantId;
          variantField.disabled = opt.unavailable === true;
        }

        if (sellingPlanField) {
          sellingPlanField.value = opt.sellingPlanId || "";
        }

        // Keep the CTA state in sync with the selected option's availability.
        this.toggleCta(opt.unavailable === true);
        this.emitStickyState();
      },

      // Disable the CTA and show the sold-out label while an unavailable option is selected.
      toggleCta(unavailable) {
        const btn = this.bundleForm?.querySelector('button[name="add"]');
        // Only the v3 buy box opts in (it renders data-ctr-cta-label); other sections sharing this component are left alone.
        if (!btn || btn.dataset.ctrCtaLabel === undefined) return;
        const label = btn.querySelector("span > strong") || btn.querySelector("span");
        const soldOutText =
          btn.querySelector(".sold-out-message")?.textContent?.trim() || "Sold out";
        const srHint = btn.querySelector(".patrol-sr-only");

        if (unavailable) {
          btn.setAttribute("disabled", "disabled");
          if (label) label.textContent = soldOutText;
          if (srHint) srHint.hidden = true;
        } else {
          btn.removeAttribute("disabled");
          if (label && btn.dataset.ctrCtaLabel) label.textContent = btn.dataset.ctrCtaLabel;
          if (srHint) srHint.hidden = false;
        }
      },

      emitStickyState() {
        try {
          const opt = this.currentOption;
          if (!opt) return;

          window.dispatchEvent(
            new CustomEvent("kilgour:buybox:change", {
              detail: {
                title: opt.title || "",
                variantId: String(opt.variantId ?? ""),
                sellingPlanId: opt.sellingPlanId
                  ? String(opt.sellingPlanId)
                  : "",
                img: opt.image || null,
                formattedPrice: opt.stickyDisplayPrice || opt.displayPrice,
                displayPrice: opt.displayPrice || "",
                priceQualifier: opt.priceQualifier || "",
                supplyBadge: opt.title || "",
                saveBadge: opt.inlineBadgeText || "",
                formattedCompareAt: opt.compareAtPrice || null,
                subtext: opt.sellingPlanId ? "Subscribe & save" : null,
                unavailable: opt.unavailable === true,
              },
            })
          );
        } catch (e) {}
      },
    };
  });
});
